<template>

  <v-card flat
          :class="{ 'my-1': hover}"
          :elevation="hover ? 6 : 0"
          @mouseenter="hover=true"
          @mouseleave="hover=false"
  >
    <v-card-text>
    <v-row >
      <v-col cols="12" md="6" offset-md="3" class="text-left">
        <v-list dense>
          <v-list-item >
            <v-list-item-avatar size="30">
              <v-icon>shopping_cart</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
              {{ $t('delivery.cart.products') }}:
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-list-item-title class="text-h6">
                {{ currencyFormat($store.getters.orderSystem.cartService.getPromosAndItemsAmount) }}
              </v-list-item-title>
            </v-list-item-action-text>
          </v-list-item>

          <v-list-item v-if="$store.getters.orderSystem.cartService.getDeliveryCost">
            <v-list-item-avatar size="30">
              <v-icon>delivery_dining</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
              {{ $t('delivery.cart.deliveryCost') }}:
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-list-item-title class="text-h6">
                {{ currencyFormat($store.getters.orderSystem.cartService.getDeliveryCost) }}
              </v-list-item-title>
            </v-list-item-action-text>
          </v-list-item>

          <v-list-item v-if="$store.getters.orderSystem.cartService.getTotalDiscount">
            <v-list-item-avatar size="30">
              <v-icon>discount</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{ $t('delivery.cart.discount') }}:
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-list-item-title class="text-h6">
                <span v-if="$store.getters.orderSystem.order.discountRate > 0" class="mr-3 font-weight-thin">
                  (-{{$store.getters.orderSystem.order.discountRate}}%)</span>
                <b> -{{ currencyFormat($store.getters.orderSystem.cartService.getTotalDiscount) }}</b>
              </v-list-item-title>
            </v-list-item-action-text>
          </v-list-item>


          <v-list-item>
            <v-list-item-avatar size="30">
              <v-icon>payments</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
              {{ $t('delivery.cart.total') }}:
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-list-item-title class="text-h6">
                  <span v-if="$store.getters.orderSystem.cartService.getTotalDiscount > 0" class="text-decoration-line-through grey--text">
                    {{ currencyFormat($store.getters.orderSystem.cartService.getTotalDiscount) }}
                  </span>
                  <b > {{ currencyFormat($store.getters.orderSystem.cartService.getTotalAmountWithDiscount)}}</b>
              </v-list-item-title>
            </v-list-item-action-text>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";

export default {
  name: "OrderReviewTotal",
  props: {
    enableTotalQuantity: {type: Boolean, default: false},
    showDiscount: {type: Boolean, default: false},
  },
  mixins: [CurrencyMixin],
  data(){
    return {
      hover: false
    }
  }
}
</script>

<style scoped>

</style>
